<div class="modal-header">
  <h4 class="modal-title">Update details</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
  </button>
</div>
<div
  class="modal-body">
  <p>
    To update your details you need to upgrade to either {{plan1Name}} or {{plan2Name}} plan.
  </p>

  <div class="row row-cols-2 mt-4 text-center">
    <div class="col mb-4 ">
      <div class="card h-100 d-inline-block d-flex flex-column">
        <div class="card-header">
          <h4 class="my-0 fw-normal">
            {{plan1Name}}
          </h4>
        </div>
        <div class="card-body">
          <h6>
            Unlimited changes to your account for the lifetime of your membership.
          </h6>
        </div>
        <div class="card-footer d-flex flex-column justify-content-end">
          <button
            class="btn btn-lg w-100 btn-brand-orange"
            (click)="buySubscription(isAtUser ? pricingPlans.atIdentibasePlusCod : pricingPlans.identibasePlusCod)"
            type="button">
            Join
          </button>
        </div>
      </div>
    </div> 

    <div class="col mb-4">
      <div class="card h-100 d-inline-block d-flex flex-column">
        <div class="card-header">
          <h4 class="my-0 fw-normal">
            {{plan2Name}}
          </h4>
        </div>
        <div class="card-body">
          <h6>
            Unlimited changes to your account, access to our enhanced missing pet service and other perks and benefits.
          </h6>
        </div>
        <div class="card-footer d-flex flex-column justify-content-end">
          <button
            class="btn btn-lg w-100 btn-success text-white"
            (click)="buySubscription(pricingPlans.identiAlertAnnual)"
            type="button">
            Join
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
